// ────────────────────────────────────────────────────────────────
// Participant Charts API client (Day 1 — Foundation Only)
// Thin wrapper around axios `api` for participant-chart endpoints.
// All routes are feature-flag gated server-side (charts_module_enabled).
// ────────────────────────────────────────────────────────────────

import api from '@/lib/api';

export async function listCharts(participantId, { status } = {}) {
  const params = {};
  if (status) params.status = status;
  const res = await api.get(`/participants/${participantId}/charts`, { params });
  return res.data?.data || [];
}

export async function createChart(participantId, payload) {
  const res = await api.post(`/participants/${participantId}/charts`, payload);
  return res.data?.data;
}

export async function getChart(participantId, chartId) {
  const res = await api.get(`/participants/${participantId}/charts/${chartId}`);
  return res.data?.data;
}

export async function updateChart(participantId, chartId, payload) {
  const res = await api.put(`/participants/${participantId}/charts/${chartId}`, payload);
  return res.data?.data;
}

export async function archiveChart(participantId, chartId) {
  const res = await api.delete(`/participants/${participantId}/charts/${chartId}`);
  return res.data?.data;
}

// Shared template registry. Actual options shown in the creation picker are
// filtered by the enabled feature flags on the frontend (see ParticipantChartCreateModal).
// Order here controls display order in the template picker.
export const AVAILABLE_TEMPLATES = [
  { code: 'bowel_chart', name: 'Bowel Chart', category: 'clinical', flag: 'bowel_chart_enabled' },
  { code: 'sleep_chart', name: 'Sleep Chart', category: 'clinical', flag: 'sleep_chart_enabled' },
  { code: 'pain_chart', name: 'Pain Chart', category: 'clinical', flag: 'pain_chart_enabled', requires: ['multi_chart_templates_enabled'] },
  { code: 'fluid_intake_chart', name: 'Fluid Intake Chart', category: 'clinical', flag: 'fluid_intake_chart_enabled', requires: ['multi_chart_templates_enabled'] },
  { code: 'behaviour_chart', name: 'Behaviour Chart (ABC)', category: 'clinical', flag: 'behaviour_chart_enabled', requires: ['multi_chart_templates_enabled'] },
  { code: 'wound_chart', name: 'Wound Chart', category: 'clinical', flag: 'wound_chart_enabled', requires: ['multi_chart_templates_enabled'] },
];

// Templates that use the dynamic field engine (vs bespoke bowel/sleep UI).
export const DYNAMIC_TEMPLATE_CODES = new Set([
  'pain_chart', 'fluid_intake_chart', 'behaviour_chart', 'wound_chart',
]);

export const MONITORING_FREQUENCIES = [
  { value: 'daily', label: 'Daily' },
  { value: 'per_shift', label: 'Per shift' },
  { value: 'twice_daily', label: 'Twice daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'as_needed', label: 'As needed' },
  { value: 'custom', label: 'Custom' },
];
